/*
 *
 * MerchantLayout
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 25-Nov-2024
 */

import MerchantLayout from './MerchantLayout'

export default MerchantLayout
